// frontend/src/components/admin/tenants/ouTree/leafStatus.ts
/**
 * Status de uma row de tenant (folha da arvore). Migrado de tenantGrouping.ts.
 *
 * Diferenca importante: aqui NAO ha agregacao (cada row tem um status proprio).
 * O grupo agregado de antes deixou de existir.
 */
import type { TenantRow } from '../TenantsTable'

export type LeafStatus =
  | 'ready'
  | 'provisioning'
  | 'failed'
  | 'inactive'
  | 'unknown'

export const STATUS_LABELS: Record<LeafStatus, string> = {
  ready: 'Pronto',
  provisioning: 'Provisionando',
  failed: 'Falha',
  inactive: 'Inativo',
  unknown: 'Importado',
}

export const STATUS_COLORS: Record<LeafStatus, string> = {
  ready: 'teal',
  provisioning: 'blue',
  failed: 'red',
  inactive: 'gray',
  unknown: 'gray',
}

export const STATUS_DESCRIPTIONS: Record<LeafStatus, string> = {
  ready:
    'Conta provisionada pelo ConsoleAI e pronta para uso.',
  provisioning:
    'Provisionamento em andamento (criando conta/OU/recursos AWS).',
  failed:
    'Falha no provisionamento. Veja Provisioning Jobs para detalhes e use Retry.',
  inactive:
    'Conta desativada manualmente (is_active=0). Reative via PATCH /admin/tenants/{id}.',
  unknown:
    'Conta descoberta pelo org_sync na AWS Organizations (existia antes do ConsoleAI).',
}

/** Resolve o status de uma row pra escolher cor/label. */
export function getLeafStatus(tenant: TenantRow): LeafStatus {
  if (!tenant.is_active) return 'inactive'
  const s = tenant.provisioning_status
  if (s === 'failed') return 'failed'
  if (s === 'provisioning') return 'provisioning'
  if (s === 'ready') return 'ready'
  return 'unknown'
}

/**
 * Deep link para a conta na AWS Organizations Console.
 * Retorna null se account_id nao tiver formato esperado (12 digitos).
 */
export function awsOrgConsoleAccountUrl(
  accountId: string | null | undefined,
): string | null {
  if (!accountId || !/^\d{12}$/.test(accountId)) return null
  return `https://us-east-1.console.aws.amazon.com/organizations/v2/home/accounts/${accountId}`
}
